import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  className?: string;
}

export const DashboardFooter: React.FC<Props> = ({ className }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={`container__footer ${className || ''}`}>
      <footer className="footer">
        <div className="footer__wrapper f f--col">
          <div className="footer__container">
            <div className="f f--col footer__rights-reserved">
              <div className="f footer__ownership">
                <a
                  className="logo__link"
                  href={formatMessage({
                    id: 'routes.home',
                  })}
                  rel="noreferrer"
                  data-cy="logo-link-footer"
                >
                  <svg
                    width="70"
                    height="18"
                    viewBox="0 0 70 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.6" clipPath="url(#clip0_14780_31968)">
                      <mask
                        id="mask0_14780_31968"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="70"
                        height="18"
                      >
                        <path
                          d="M69.7674 0H0V17.9873H69.7674V0Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0_14780_31968)">
                        <path
                          d="M12.9849 5.5523C12.9849 2.67859 10.945 0 7.14879 0C3.35267 0 0.815993 2.71406 0 5.62326C2.0932 6.13769 3.49458 8.03574 2.74954 10.3241L1.2772 14.883H3.76067L4.81826 11.6943C5.30236 11.8048 5.83081 11.8851 6.38604 11.8851C9.59679 11.8851 12.9849 9.24202 12.9849 5.5523ZM4.78953 4.29283L4.26215 5.8214C3.96963 5.21579 3.55898 4.80957 3.07878 4.50287C3.62549 3.58505 4.97614 2.34155 6.98916 2.34155C9.20651 2.34155 10.466 3.8671 10.466 5.51683C10.466 7.64553 8.39051 9.49032 6.40377 9.49032C6.13254 9.49032 5.85795 9.45432 5.57962 9.39886L7.27298 4.29283H4.78953Z"
                          fill="#B9B9B9"
                        />
                        <path
                          d="M55.6287 12.6301L59.7445 8.26638L60.2589 6.01349H53.4294C53.1113 7.31307 52.2439 7.96603 51.1377 8.19096C50.4577 6.70177 48.9914 5.72967 47.1675 5.72967C45.6014 5.72967 44.2002 6.44562 43.2786 7.57184C42.6208 8.37598 41.8623 9.09193 41.0355 9.72096L40.8325 9.87528C40.7425 7.23891 38.7067 5.72967 36.9144 5.72967C36.12 5.72967 35.2416 6.03124 34.4526 6.57139L34.626 6.01349H32.7635L32.0878 8.10542L29.7125 9.90968C29.6013 7.49419 27.795 5.72967 25.3484 5.72967C23.9514 5.72967 22.686 6.29927 21.7749 7.22168C21.3215 7.68061 20.8285 8.09872 20.3107 8.48328L19.0902 9.39012L19.4059 8.07103C19.6897 6.84705 18.9091 5.72949 17.6497 5.72949C17.0206 5.72949 16.3079 6.00871 15.6599 6.61592L15.858 6.01332H13.9067L11.0508 14.8828H13.4455L15.3614 8.95798C15.521 8.46131 15.8758 8.07103 16.3193 8.07103C16.8159 8.07103 17.0642 8.58549 16.8692 9.20635L16.5498 10.1997C16.1774 11.335 16.9223 12.2397 17.969 12.2397C18.3592 12.2397 18.8382 12.1332 19.3703 11.7253L20.335 11.0104C20.4584 13.4298 22.2957 15.1667 24.7453 15.1667C26.3595 15.1667 27.3706 14.4216 28.4349 13.5879L30.9644 11.5832L28.8962 17.9871H31.2909L32.751 13.4758C33.3627 14.4455 34.3848 15.1667 35.8499 15.1667C37.3149 15.1667 38.3688 14.4748 39.3799 13.6943L42.2019 11.4883C42.5272 13.6553 44.2793 15.1667 46.5642 15.1667C49.2524 15.1667 51.4215 13.0406 51.5432 10.3823C53.1226 10.1071 54.0543 9.29642 54.8128 8.26617H56.6602L52.5245 12.63L52.0101 14.8828H57.9711C58.9978 14.8828 59.9992 14.5642 60.8372 13.9708L61.2943 13.6473C62.0425 14.5445 63.2025 15.1667 64.8176 15.1667C67.0882 15.1667 68.7557 13.9427 69.7668 12.8428L68.259 11.1931C67.3011 12.0978 66.3609 12.8251 65.1369 12.8251C64.587 12.8251 64.0973 12.672 63.705 12.4004L69.5332 9.18556C68.7704 7.26975 67.2124 5.72949 65.0837 5.72949C62.5648 5.72949 60.2409 7.89368 60.2409 10.6254C60.2409 10.9859 60.2805 11.3522 60.3607 11.7125C59.5213 12.3093 58.5168 12.63 57.4867 12.63H55.6283L55.6287 12.6301ZM24.8873 12.8253C23.6633 12.8253 22.8119 11.9029 22.8119 10.6079C22.8119 9.17105 23.8585 8.07124 25.1889 8.07124C26.4129 8.07124 27.2467 8.99363 27.2467 10.2886C27.2467 11.7077 26.2178 12.8253 24.8873 12.8253ZM35.9919 12.8253C34.7679 12.8253 33.9165 11.9029 33.9165 10.6079C33.9165 9.17105 34.9631 8.07124 36.2935 8.07124C37.5175 8.07124 38.3513 8.99363 38.3513 10.2886C38.3513 11.7077 37.3224 12.8253 35.9919 12.8253ZM46.7063 12.8253C45.4823 12.8253 44.6308 11.9029 44.6308 10.6079C44.6308 9.17105 45.6775 8.07124 47.0079 8.07124C48.2319 8.07124 49.0656 8.99363 49.0656 10.2886C49.0656 11.7077 48.0367 12.8253 46.7063 12.8253ZM64.9065 7.96477C65.4832 7.96477 65.8955 8.17024 66.2758 8.60517L62.7275 10.5432C62.7255 10.5002 62.7246 10.4567 62.7246 10.4129C62.7246 8.99384 63.7002 7.96498 64.9065 7.96498V7.96477Z"
                          fill="#B9B9B9"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_14780_31968">
                        <rect width="69.7674" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>

              <p className="s-top--tny t-text-3">
                Version: {process.env.GATSBY_APP_VERSION?.split('-')[0]}
              </p>
            </div>
            <div className="f footer__links">
              <a
                className="text--sm t-text-3"
                href={formatMessage({ id: 'routes.terms-of-service' })}
                data-cy="terms-of-service-link"
                rel="noopener noreferrer"
              >
                <FormattedMessage id="terms-of-service.title" />
              </a>
              <span className="t-small t-bg-faded footer__terms-service__divider s-lr--12">
                •
              </span>
              <a
                className="text--sm t-text-3"
                href={formatMessage({ id: 'routes.privacy-policy' })}
                data-cy="privacy-policy-link"
                rel="noopener noreferrer"
              >
                <FormattedMessage id="privacy-policy.title" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
